export default __webpack_public_path__ + "static/media/pattern1-purple.dee4879c.svg";